"use strict";

exports.__esModule = true;
var _AuditLogListScreen = require("./AuditLogListScreen");
Object.keys(_AuditLogListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogListScreen[key]) return;
  exports[key] = _AuditLogListScreen[key];
});
var _AuditLogDetails = require("./AuditLogDetails");
Object.keys(_AuditLogDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogDetails[key]) return;
  exports[key] = _AuditLogDetails[key];
});
var _AuditLogRoutes = require("./AuditLogRoutes");
Object.keys(_AuditLogRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogRoutes[key]) return;
  exports[key] = _AuditLogRoutes[key];
});
var _AuditLogGrid = require("./AuditLogGrid");
Object.keys(_AuditLogGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogGrid[key]) return;
  exports[key] = _AuditLogGrid[key];
});
var _AuditLogContext = require("./AuditLogContext");
Object.keys(_AuditLogContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogContext[key]) return;
  exports[key] = _AuditLogContext[key];
});
var _AuditLogListToolbar = require("./AuditLogListToolbar");
Object.keys(_AuditLogListToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogListToolbar[key]) return;
  exports[key] = _AuditLogListToolbar[key];
});